module.exports = __webpack_public_path__ + "img/certlogo.0610a991.png";